<template>
    <div class="login-root">
        <div class="login-main">
            <div class="clearfix"
                 style="width: 900px; margin: auto;">
                <div class="login-container">
                    <section class="login-desc">
                        <div class="login-desc-icon">
                            <img src="//awp-assets.meituan.net/hfe/fep/a8e56801f64e0c6261770c41ed95a679/loginlogo.svg" />
                        </div>
                        <div class="login-desc-title">
                            境内度假商家中心
                        </div>
                        <ul class="list-unstyled">
                            <li>基于新美大双平台强大的流量优势</li>
                            <li>一站式解决旅游商家从日常运营到渠道拓展的全部诉求</li>
                        </ul>
                    </section>
                </div>
                <div class="login-box">
                    <div class="iframe-title">商家登录</div>
                    <iframe v-if="loginSrc"
                            id="login-content-iframe"
                            v-bind:src="loginSrc"
                            frameborder="0">
                        美团商家登录平台使用了框架技术，但是您的浏览器不支持框架，请升级您的浏览器以便正常访问。
                    </iframe>
                </div>
            </div>
        </div>
        <footer-bar show-mark="true"></footer-bar>
    </div>
</template>
<style lang="scss" scoped>
    .login {
      &-main {
        position: relative;
        background: url("~static/img/login-bg.png") no-repeat center;
        background-size: cover;
        padding: 80px 0;
      }
      &-container {
        width: 400px;
        padding-top: 50px;
        height: 400px;
        float: left;
        vertical-align: middle;
      }
      &-box {
        background-color: #fff;
        width: 360px;
        float: right;
        .iframe-title {
          font-size: 18px;
          font-weight: 400;
          color: #333;
          padding: 30px 0 0 20px;
        }
        iframe {
          width: 100%;
          height: 380px;
          background-color: #fff;
          overflow: hidden;
        }
      }
      &-desc {
        display: inline-block;
        line-height: 20px;
        color: #fafafa;
        font-size: 17px;
        &-title {
          line-height: 40px;
          font-size: 30px;
        }
      }
    }
    .login-root {
      display: flex;
      flex-direction: column;
      height: 100%;
      & > .login-main {
        flex: 1 1 1px;
      }
      & > .footer {
        flex: 0 0 auto;
        padding-bottom: 20px;
      }
      .copyright {
        margin: 5px 0 !important;
      }
    }
</style>

<script>
    import { mapActions } from "vuex";
    import { apiHost, loginHost } from "config/env.conf";
    import { dxEnvUrlMap } from "config/common";
    import { FooterBar } from "components/layout";
    export default {
        data() {
            return {
                setTokenUrl: `${apiHost}/rimet/out/auth/redirect?feclient=lvyou_web`,
                loginSrc: null
            };
        },
        components: {
            FooterBar
        },
        methods: {
            ...mapActions(["formPage"]),
            getLoginSrc() {
                const pathname =
                    location.pathname.indexOf("index.html") > -1
                        ? location.pathname.replace("index.html", "redirect.html")
                        : location.pathname + "redirect.html";
                const redirectUrl = `${window.location.protocol}//${location.host}${pathname}`;
                let href = window.location.href;
                let referrerUrl = "";
                let gotoUrl = "";
                if (href.includes(dxEnvUrlMap[ENV])) {
                    let urlReg = /[?&]redirect_uri=(.+?)(&|$|#)/;
                    let matchArr = urlReg.exec(href);
                    if (matchArr && matchArr[1]) {
                        referrerUrl = matchArr[1];
                        gotoUrl = `${
                            window.location.protocol
                            }${apiHost}/rimet/out/xmAuth/redirect?feclient=lvyou_web&redirectUrl=${referrerUrl}`;
                    }
                }
                gotoUrl = encodeURIComponent(gotoUrl);
                const continueUrl = `${window.location.protocol.replace(':', '')}:${
                    this.setTokenUrl
                    }&redirect=${encodeURIComponent(
                        redirectUrl + (gotoUrl ? "?goto=" + gotoUrl : "")
                    )}`;
                return `${loginHost}/account/unitivelogin?bg_source=5&service=lvyou&continue=${encodeURIComponent(
                    continueUrl
                )}`;
            }
        },
        mounted() {
            this.loginSrc = this.getLoginSrc();
            window.LOGINSUCCESSCALLBACK = () => {
                if (this.fromPage && this.fromPage.path !== "/login") {
                    this.$router.replace(this.fromPage);
                } else {
                    this.$router.replace({ name: "newHome" });
                }
            };
        }
    };
</script>



// WEBPACK FOOTER //
// Main.vue?b7775d16